import { defineMessages } from "react-intl";
const messages = defineMessages({
    topRankingTitle: {
        id: "app.aiDiscoverability.topRanking.title",
        defaultMessage: "Top Ranking",
    },
    mostCitedBy: {
        id: "app.aiDiscoverability.topRanking.mostCitedBy",
        defaultMessage: "Most cited by:",
    },
    bestPerforming: {
        id: "app.aiDiscoverability.topRanking.bestPerforming",
        defaultMessage: "Best performing: {features}",
    },
    topRankedAriaLabel: {
        id: "app.aiDiscoverability.topRanking.topRankedAriaLabel",
        defaultMessage: "Top ranked",
    },
    scoreNotAvailable: {
        id: "app.aiDiscoverability.topRanking.scoreNotAvailable",
        defaultMessage: "N/A",
    },
    youRankLabel: {
        id: "app.aiDiscoverability.topRanking.youRankLabel",
        defaultMessage: "You - #{rank}",
    },
    youBadgeLabel: {
        id: "app.aiDiscoverability.topRanking.youBadgeLabel",
        defaultMessage: "You",
    },
    minLabel: {
        id: "app.aiDiscoverability.topRanking.minLabel",
        defaultMessage: "(min)",
    },
    maxLabel: {
        id: "app.aiDiscoverability.topRanking.maxLabel",
        defaultMessage: "(max)",
    },
    tooltipMin: {
        id: "app.aiDiscoverability.topRanking.tooltipMin",
        defaultMessage: "Minimum Score: {min}",
    },
    tooltipMax: {
        id: "app.aiDiscoverability.topRanking.tooltipMax",
        defaultMessage: "Maximum Score: {max}",
    },
    tooltipLowerBoxTitle: {
        id: "app.aiDiscoverability.topRanking.tooltipLowerBoxTitle",
        defaultMessage: "Lower performing communities",
    },
    tooltipLowerBox: {
        id: "app.aiDiscoverability.topRanking.tooltipLowerBox",
        defaultMessage: "Communities in the 25th - 50th percentile",
    },
    tooltipMedianTitle: {
        id: "app.aiDiscoverability.topRanking.tooltipMedianTitle",
        defaultMessage: "Median",
    },
    tooltipMedian: {
        id: "app.aiDiscoverability.topRanking.tooltipMedian",
        defaultMessage: "The midpoint of all community scores",
    },
    tooltipUpperBoxTitle: {
        id: "app.aiDiscoverability.topRanking.tooltipUpperBoxTitle",
        defaultMessage: "Better performing communities",
    },
    tooltipUpperBox: {
        id: "app.aiDiscoverability.topRanking.tooltipUpperBox",
        defaultMessage: "Communities in the 50th - 75th percentile",
    },
    tooltipYou: {
        id: "app.aiDiscoverability.topRanking.tooltipYou",
        defaultMessage: "You're ranked #{rank} of {total} communities",
    },
});
export default messages;
